/**
 * Auto generated file, please don't edit.
 *
 * With: Gobl v1.0.0
 * Time: 1561690622
 */

export type tGoblEntityData = {
	[ key: string ]: any
};
export type tGoblCache<T> = { [ key: string ]: T };

const win: any = window,
	gobl: any = win.gobl = win.gobl || {},
	_hasOwn = Object.hasOwnProperty,
	_isPlainObject = (a: any): boolean => Object.prototype.toString.call(a) === "[object Object]",
	_c_bool = (v: any): boolean => {
		// @ts-ignore
		return (v === null || v === undefined) ? v : Boolean(v === "0" ? 0 : v);
	},
	_c_int = (v: any): number => {
		// @ts-ignore
		return (v === null || v === undefined) ? v : parseInt(v);
	},
	_c_string = (v: any): string => {
		// @ts-ignore
		return (v === null || v === undefined) ? "" : String(v);
	},
	gobl_marker = "__gobl__",
	gobl_cache: {
		[ entity: string ]: tGoblCache<GoblEntity>
	} = {},
	gobl_class_magic_map: { [ key: string ]: string } = {},
	realJSONParse = JSON.parse,
	goblJSONParse = function (text: any, reviver?: (key: any, value: any) => any) {
		return realJSONParse(text, function (key, value) {
			if (typeof reviver === "function") {
				value = reviver(key, value);
			}

			if (_isPlainObject(value)) {
				let i = GoblEntity.toInstance(value, true);
				if (i) {
					return i;
				}
			}

			return value;
		});
	},
	ACTION_UNKNOWN = 0,
	ACTION_SAVING = 1,
	ACTION_DELETING = 2,
	ACTION_UPDATING = 3;

/**
 * GoblEntity class.
 *
 * To prevent conflict between:
 * - entity class property name and column magic getter and setter
 * - entity class method and column method (getter and setter)
 * We only use:
 * - a prefix with a single `_` for property
 * - camelCase method name avoiding prefixing with `get` or `set`
 * So don't use:
 * - `getSomething`, `setSomething` or `our_property`
 * Use instead:
 * - `_getSomething`, `_setSomething`, `doSomething` or `_our_property`
 */

export abstract class GoblEntity {
	protected readonly _data: any = {};
	protected _cache: any = {};
	protected _action: number = ACTION_UNKNOWN;

	protected constructor(_initial_data: tGoblEntityData = {}, private readonly _name: string, private readonly _prefix: string, private readonly _columns: string[]) {
		let ctx = this,
			// we use null not undefined since JSON.stringify will ignore properties with undefined value
			_def: null = null;

		_columns.forEach(function (col) {
			ctx._data[ col ] = ctx._cache[ col ] = (col in _initial_data) ? _initial_data[ col ] : _def;
		});
	}

	/**
	 * Magic setter.
	 *
	 * @param column
	 * @param value
	 */
	protected _set(column: string, value: any): this {
		if (_hasOwn.call(this._data, column)) {
			this._data[ column ] = value;
		}

		return this;
	}

	/**
	 * Checks is the entity is clean.
	 */
	isClean(): boolean {
		return Object.keys(this.toObject(true)).length === 0
	}

	/**
	 * Checks if the entity is saved.
	 *
	 * @param set When true the entity will be considered as saved.
	 */
	isSaved(set?: boolean): boolean {
		if (set) {
			this._cache = this.toObject();
			return true;
		}

		return this.isClean()
	}

	/**
	 * Checks if the entity is beeing saved.
	 *
	 * @param set When true the state will be set to saving.
	 */
	isSaving(set?: boolean): boolean {
		if (arguments.length) {
			this._action = set ? ACTION_SAVING : ACTION_UNKNOWN;
		}

		return this._action === ACTION_SAVING;
	}

	/**
	 * Checks if the entity is beeing deleted.
	 *
	 * @param set When true the state will be set to deleting.
	 */
	isDeleting(set?: boolean): boolean {
		if (arguments.length) {
			this._action = set ? ACTION_DELETING : ACTION_UNKNOWN;
		}

		return this._action === ACTION_DELETING;
	}

	/**
	 * Checks if the entity is beeing updated.
	 *
	 * @param set When true the state will be set to updating.
	 */
	isUpdating(set?: boolean): boolean {
		if (arguments.length) {
			this._action = set ? ACTION_UPDATING : ACTION_UNKNOWN;
		}

		return this._action === ACTION_UPDATING;
	}

	/**
	 * Hydrate the entity and set as saved when `save` is true
	 */
	doHydrate(data: tGoblEntityData, save: boolean = false): this {
		let ctx = this,
			source_of_truth = this._data;

		Object.keys(data).forEach(function (k) {
			if (_hasOwn.call(source_of_truth, k)) {
				(ctx as any)[ k.slice(ctx._prefix.length + 1) ] = data[ k ];
			}
		});

		if (save) {
			this.isSaved(true);
		}

		return this;
	}

	/**
	 * Returns current data in a clean new object
	 *
	 * if `diff` is true, returns modified columns only
	 */
	toObject(diff: boolean = false): tGoblEntityData {
		let o: any = {};

		if (diff) {
			for (let k in this._cache) {
				if (_hasOwn.call(this._cache, k)) {
					if (this._cache[ k ] !== this._data[ k ]) {
						o[ k ] = this._data[ k ];
					}
				}
			}
			return o;
		}

		for (let k in this._data) {
			if (_hasOwn.call(this._data, k)) {
				o[ k ] = this._data[ k ];
			}
		}

		return o;
	}

	/**
	 * Returns some column values
	 */
	toObjectSome(columns: string[]): tGoblEntityData {
		let o: any = {}, len = columns.length;

		for (let i = 0; i < len; i++) {
			let col = columns[ i ];
			if (_hasOwn.call(this._data, col)) {
				o[ col ] = this._data[ col ];
			} else {
				throw new Error(`Column "${ col }" is not defined in "${ this._name }".`);
			}
		}

		return o;
	}

	/**
	 * JSON helper
	 */
	toJSON(): any {
		let data = this.toObject();
		data[ gobl_marker ] = this._name;

		return data;
	}

	/**
	 * Try to identify and instanciate the entity class that best matches the given data.
	 *
	 * @param data
	 * @param cache
	 */
	static toInstance(data: tGoblEntityData, cache = false): GoblEntity | undefined {
		if (_isPlainObject(data)) {
			let entity_name = data[ gobl_marker ],
				entity, magic, old: GoblEntity, e: GoblEntity, cache_key;

			if (entity_name) {
				entity = gobl[ entity_name ];
				// maybe the entity name change
				// this is to have a clean object
				delete data[ gobl_marker ];
			}

			if (!entity) {
				magic = Object.keys(data).sort().join("");
				entity_name = gobl_class_magic_map[ magic ];

				if (entity_name) {
					entity = gobl[ entity_name ];
				}
			}

			if (entity) {
				e = new entity(data);
				if (true === cache && (cache_key = e.cacheKey())) {
					old = gobl_cache[ entity_name ][ cache_key ];
					if (old) {
						e = old.doHydrate(data);
					}

					gobl_cache[ entity_name ][ cache_key ] = e;

				}

				return e;
			}
		}

		return undefined;
	}

	/**
	 * Returns a given entity cache.
	 *
	 * @param entity
	 */
	static subCache(entity: string): tGoblCache<GoblEntity> | undefined {
		return gobl_cache[ entity ];
	}

	/**
	 * Returns the entity cache key.
	 *
	 * `null` is returned when we can't have a valid cache key.
	 */
	cacheKey(): string | null {
		let columns = this.identifierColumns().sort(),
			len = columns.length,
			value = "", i = 0;

		if (len === 1) {
			value = this._data[ columns[ 0 ] ];
		} else {
			for (; i < len; i++) {
				let v = this._data[ columns[ i ] ];
				if (v != null) {
					value += v;
				}
			}
		}

		return value || null;
	}

	/**
	 * Returns the primary keys of the entity.
	 */
	abstract identifierColumns(): string[]
}


export abstract class GoblSinglePKEntity extends GoblEntity {
	abstract singlePKValue(): string
}


export class OZUser extends GoblEntity {
	static readonly PREFIX:string = 'user';
	static readonly COLUMNS:string[] = 'user_id|user_phone|user_email|user_pass|user_name|user_gender|user_birth_date|user_picid|user_cc2|user_data|user_add_time|user_valid'.split('|');
	static readonly COL_ID:string = 'user_id';
	static readonly COL_PHONE:string = 'user_phone';
	static readonly COL_EMAIL:string = 'user_email';
	static readonly COL_PASS:string = 'user_pass';
	static readonly COL_NAME:string = 'user_name';
	static readonly COL_GENDER:string = 'user_gender';
	static readonly COL_BIRTH_DATE:string = 'user_birth_date';
	static readonly COL_PICID:string = 'user_picid';
	static readonly COL_CC2:string = 'user_cc2';
	static readonly COL_DATA:string = 'user_data';
	static readonly COL_ADD_TIME:string = 'user_add_time';
	static readonly COL_VALID:string = 'user_valid';

	constructor(data?: tGoblEntityData) {
		super(data, "OZUser", OZUser.PREFIX, OZUser.COLUMNS);
	}
	
	singlePKValue(){
		return this.id;
	}
	identifierColumns(){
		return [OZUser.COL_ID,];
	}
	static fromCache(cache_key: string): OZUser | undefined {
		let cache = <any>gobl_cache["OZUser"];
		return cache && cache[cache_key];
	}

	get id(){ return _c_string(this._data[OZUser.COL_ID])}
	set id(nVal:any){ this._set(OZUser.COL_ID, _c_string(nVal))}
	getId(){ return this.id}
	setId(nVal:any):this { this.id = nVal; return this}
	get phone(){ return _c_string(this._data[OZUser.COL_PHONE])}
	set phone(nVal:any){ this._set(OZUser.COL_PHONE, _c_string(nVal))}
	getPhone(){ return this.phone}
	setPhone(nVal:any):this { this.phone = nVal; return this}
	get email(){ return _c_string(this._data[OZUser.COL_EMAIL])}
	set email(nVal:any){ this._set(OZUser.COL_EMAIL, _c_string(nVal))}
	getEmail(){ return this.email}
	setEmail(nVal:any):this { this.email = nVal; return this}
	get pass(){ return _c_string(this._data[OZUser.COL_PASS])}
	set pass(nVal:any){ this._set(OZUser.COL_PASS, _c_string(nVal))}
	getPass(){ return this.pass}
	setPass(nVal:any):this { this.pass = nVal; return this}
	get name(){ return _c_string(this._data[OZUser.COL_NAME])}
	set name(nVal:any){ this._set(OZUser.COL_NAME, _c_string(nVal))}
	getName(){ return this.name}
	setName(nVal:any):this { this.name = nVal; return this}
	get gender(){ return _c_string(this._data[OZUser.COL_GENDER])}
	set gender(nVal:any){ this._set(OZUser.COL_GENDER, _c_string(nVal))}
	getGender(){ return this.gender}
	setGender(nVal:any):this { this.gender = nVal; return this}
	get birth_date(){ return _c_string(this._data[OZUser.COL_BIRTH_DATE])}
	set birth_date(nVal:any){ this._set(OZUser.COL_BIRTH_DATE, _c_string(nVal))}
	getBirthDate(){ return this.birth_date}
	setBirthDate(nVal:any):this { this.birth_date = nVal; return this}
	get picid(){ return _c_string(this._data[OZUser.COL_PICID])}
	set picid(nVal:any){ this._set(OZUser.COL_PICID, _c_string(nVal))}
	getPicid(){ return this.picid}
	setPicid(nVal:any):this { this.picid = nVal; return this}
	get cc2(){ return _c_string(this._data[OZUser.COL_CC2])}
	set cc2(nVal:any){ this._set(OZUser.COL_CC2, _c_string(nVal))}
	getCc2(){ return this.cc2}
	setCc2(nVal:any):this { this.cc2 = nVal; return this}
	get data(){ return _c_string(this._data[OZUser.COL_DATA])}
	set data(nVal:any){ this._set(OZUser.COL_DATA, _c_string(nVal))}
	getData(){ return this.data}
	setData(nVal:any):this { this.data = nVal; return this}
	get add_time(){ return _c_string(this._data[OZUser.COL_ADD_TIME])}
	set add_time(nVal:any){ this._set(OZUser.COL_ADD_TIME, _c_string(nVal))}
	getAddTime(){ return this.add_time}
	setAddTime(nVal:any):this { this.add_time = nVal; return this}
	get valid(){ return _c_bool(this._data[OZUser.COL_VALID])}
	set valid(nVal:any){ this._set(OZUser.COL_VALID, _c_bool(nVal))}
	getValid(){ return this.valid}
	setValid(nVal:any):this { this.valid = nVal; return this}

}

gobl.OZUser = OZUser;
export class OZAdmin extends GoblEntity {
	static readonly PREFIX:string = 'admin';
	static readonly COLUMNS:string[] = 'admin_user_id|admin_level|admin_data|admin_add_time|admin_valid'.split('|');
	static readonly COL_USER_ID:string = 'admin_user_id';
	static readonly COL_LEVEL:string = 'admin_level';
	static readonly COL_DATA:string = 'admin_data';
	static readonly COL_ADD_TIME:string = 'admin_add_time';
	static readonly COL_VALID:string = 'admin_valid';

	constructor(data?: tGoblEntityData) {
		super(data, "OZAdmin", OZAdmin.PREFIX, OZAdmin.COLUMNS);
	}
	
	singlePKValue(){
		return this.user_id;
	}
	identifierColumns(){
		return [OZAdmin.COL_USER_ID,];
	}
	static fromCache(cache_key: string): OZAdmin | undefined {
		let cache = <any>gobl_cache["OZAdmin"];
		return cache && cache[cache_key];
	}

	get user_id(){ return _c_string(this._data[OZAdmin.COL_USER_ID])}
	set user_id(nVal:any){ this._set(OZAdmin.COL_USER_ID, _c_string(nVal))}
	getUserId(){ return this.user_id}
	setUserId(nVal:any):this { this.user_id = nVal; return this}
	get level(){ return _c_int(this._data[OZAdmin.COL_LEVEL])}
	set level(nVal:any){ this._set(OZAdmin.COL_LEVEL, _c_int(nVal))}
	getLevel(){ return this.level}
	setLevel(nVal:any):this { this.level = nVal; return this}
	get data(){ return _c_string(this._data[OZAdmin.COL_DATA])}
	set data(nVal:any){ this._set(OZAdmin.COL_DATA, _c_string(nVal))}
	getData(){ return this.data}
	setData(nVal:any):this { this.data = nVal; return this}
	get add_time(){ return _c_string(this._data[OZAdmin.COL_ADD_TIME])}
	set add_time(nVal:any){ this._set(OZAdmin.COL_ADD_TIME, _c_string(nVal))}
	getAddTime(){ return this.add_time}
	setAddTime(nVal:any):this { this.add_time = nVal; return this}
	get valid(){ return _c_bool(this._data[OZAdmin.COL_VALID])}
	set valid(nVal:any){ this._set(OZAdmin.COL_VALID, _c_bool(nVal))}
	getValid(){ return this.valid}
	setValid(nVal:any):this { this.valid = nVal; return this}

}

gobl.OZAdmin = OZAdmin;
export class OZCountry extends GoblEntity {
	static readonly PREFIX:string = 'country';
	static readonly COLUMNS:string[] = 'country_cc2|country_code|country_name|country_name_real|country_data|country_add_time|country_valid'.split('|');
	static readonly COL_CC2:string = 'country_cc2';
	static readonly COL_CODE:string = 'country_code';
	static readonly COL_NAME:string = 'country_name';
	static readonly COL_NAME_REAL:string = 'country_name_real';
	static readonly COL_DATA:string = 'country_data';
	static readonly COL_ADD_TIME:string = 'country_add_time';
	static readonly COL_VALID:string = 'country_valid';

	constructor(data?: tGoblEntityData) {
		super(data, "OZCountry", OZCountry.PREFIX, OZCountry.COLUMNS);
	}
	
	singlePKValue(){
		return this.cc2;
	}
	identifierColumns(){
		return [OZCountry.COL_CC2,];
	}
	static fromCache(cache_key: string): OZCountry | undefined {
		let cache = <any>gobl_cache["OZCountry"];
		return cache && cache[cache_key];
	}

	get cc2(){ return _c_string(this._data[OZCountry.COL_CC2])}
	set cc2(nVal:any){ this._set(OZCountry.COL_CC2, _c_string(nVal))}
	getCc2(){ return this.cc2}
	setCc2(nVal:any):this { this.cc2 = nVal; return this}
	get code(){ return _c_string(this._data[OZCountry.COL_CODE])}
	set code(nVal:any){ this._set(OZCountry.COL_CODE, _c_string(nVal))}
	getCode(){ return this.code}
	setCode(nVal:any):this { this.code = nVal; return this}
	get name(){ return _c_string(this._data[OZCountry.COL_NAME])}
	set name(nVal:any){ this._set(OZCountry.COL_NAME, _c_string(nVal))}
	getName(){ return this.name}
	setName(nVal:any):this { this.name = nVal; return this}
	get name_real(){ return _c_string(this._data[OZCountry.COL_NAME_REAL])}
	set name_real(nVal:any){ this._set(OZCountry.COL_NAME_REAL, _c_string(nVal))}
	getNameReal(){ return this.name_real}
	setNameReal(nVal:any):this { this.name_real = nVal; return this}
	get data(){ return _c_string(this._data[OZCountry.COL_DATA])}
	set data(nVal:any){ this._set(OZCountry.COL_DATA, _c_string(nVal))}
	getData(){ return this.data}
	setData(nVal:any):this { this.data = nVal; return this}
	get add_time(){ return _c_string(this._data[OZCountry.COL_ADD_TIME])}
	set add_time(nVal:any){ this._set(OZCountry.COL_ADD_TIME, _c_string(nVal))}
	getAddTime(){ return this.add_time}
	setAddTime(nVal:any):this { this.add_time = nVal; return this}
	get valid(){ return _c_bool(this._data[OZCountry.COL_VALID])}
	set valid(nVal:any){ this._set(OZCountry.COL_VALID, _c_bool(nVal))}
	getValid(){ return this.valid}
	setValid(nVal:any):this { this.valid = nVal; return this}

}

gobl.OZCountry = OZCountry;
export class OZFile extends GoblEntity {
	static readonly PREFIX:string = 'file';
	static readonly COLUMNS:string[] = 'file_id|file_user_id|file_key|file_clone|file_origin|file_size|file_type|file_name|file_label|file_path|file_thumb|file_data|file_add_time|file_valid'.split('|');
	static readonly COL_ID:string = 'file_id';
	static readonly COL_USER_ID:string = 'file_user_id';
	static readonly COL_KEY:string = 'file_key';
	static readonly COL_CLONE:string = 'file_clone';
	static readonly COL_ORIGIN:string = 'file_origin';
	static readonly COL_SIZE:string = 'file_size';
	static readonly COL_TYPE:string = 'file_type';
	static readonly COL_NAME:string = 'file_name';
	static readonly COL_LABEL:string = 'file_label';
	static readonly COL_PATH:string = 'file_path';
	static readonly COL_THUMB:string = 'file_thumb';
	static readonly COL_DATA:string = 'file_data';
	static readonly COL_ADD_TIME:string = 'file_add_time';
	static readonly COL_VALID:string = 'file_valid';

	constructor(data?: tGoblEntityData) {
		super(data, "OZFile", OZFile.PREFIX, OZFile.COLUMNS);
	}
	
	singlePKValue(){
		return this.id;
	}
	identifierColumns(){
		return [OZFile.COL_ID,];
	}
	static fromCache(cache_key: string): OZFile | undefined {
		let cache = <any>gobl_cache["OZFile"];
		return cache && cache[cache_key];
	}

	get id(){ return _c_string(this._data[OZFile.COL_ID])}
	set id(nVal:any){ this._set(OZFile.COL_ID, _c_string(nVal))}
	getId(){ return this.id}
	setId(nVal:any):this { this.id = nVal; return this}
	get user_id(){ return _c_string(this._data[OZFile.COL_USER_ID])}
	set user_id(nVal:any){ this._set(OZFile.COL_USER_ID, _c_string(nVal))}
	getUserId(){ return this.user_id}
	setUserId(nVal:any):this { this.user_id = nVal; return this}
	get key(){ return _c_string(this._data[OZFile.COL_KEY])}
	set key(nVal:any){ this._set(OZFile.COL_KEY, _c_string(nVal))}
	getKey(){ return this.key}
	setKey(nVal:any):this { this.key = nVal; return this}
	get clone(){ return _c_string(this._data[OZFile.COL_CLONE])}
	set clone(nVal:any){ this._set(OZFile.COL_CLONE, _c_string(nVal))}
	getClone(){ return this.clone}
	setClone(nVal:any):this { this.clone = nVal; return this}
	get origin(){ return _c_string(this._data[OZFile.COL_ORIGIN])}
	set origin(nVal:any){ this._set(OZFile.COL_ORIGIN, _c_string(nVal))}
	getOrigin(){ return this.origin}
	setOrigin(nVal:any):this { this.origin = nVal; return this}
	get size(){ return _c_string(this._data[OZFile.COL_SIZE])}
	set size(nVal:any){ this._set(OZFile.COL_SIZE, _c_string(nVal))}
	getSize(){ return this.size}
	setSize(nVal:any):this { this.size = nVal; return this}
	get type(){ return _c_string(this._data[OZFile.COL_TYPE])}
	set type(nVal:any){ this._set(OZFile.COL_TYPE, _c_string(nVal))}
	getType(){ return this.type}
	setType(nVal:any):this { this.type = nVal; return this}
	get name(){ return _c_string(this._data[OZFile.COL_NAME])}
	set name(nVal:any){ this._set(OZFile.COL_NAME, _c_string(nVal))}
	getName(){ return this.name}
	setName(nVal:any):this { this.name = nVal; return this}
	get label(){ return _c_string(this._data[OZFile.COL_LABEL])}
	set label(nVal:any){ this._set(OZFile.COL_LABEL, _c_string(nVal))}
	getLabel(){ return this.label}
	setLabel(nVal:any):this { this.label = nVal; return this}
	get path(){ return _c_string(this._data[OZFile.COL_PATH])}
	set path(nVal:any){ this._set(OZFile.COL_PATH, _c_string(nVal))}
	getPath(){ return this.path}
	setPath(nVal:any):this { this.path = nVal; return this}
	get thumb(){ return _c_string(this._data[OZFile.COL_THUMB])}
	set thumb(nVal:any){ this._set(OZFile.COL_THUMB, _c_string(nVal))}
	getThumb(){ return this.thumb}
	setThumb(nVal:any):this { this.thumb = nVal; return this}
	get data(){ return _c_string(this._data[OZFile.COL_DATA])}
	set data(nVal:any){ this._set(OZFile.COL_DATA, _c_string(nVal))}
	getData(){ return this.data}
	setData(nVal:any):this { this.data = nVal; return this}
	get add_time(){ return _c_string(this._data[OZFile.COL_ADD_TIME])}
	set add_time(nVal:any){ this._set(OZFile.COL_ADD_TIME, _c_string(nVal))}
	getAddTime(){ return this.add_time}
	setAddTime(nVal:any):this { this.add_time = nVal; return this}
	get valid(){ return _c_bool(this._data[OZFile.COL_VALID])}
	set valid(nVal:any){ this._set(OZFile.COL_VALID, _c_bool(nVal))}
	getValid(){ return this.valid}
	setValid(nVal:any):this { this.valid = nVal; return this}

}

gobl.OZFile = OZFile;
export class SXSector extends GoblEntity {
	static readonly PREFIX:string = 'sector';
	static readonly COLUMNS:string[] = 'sector_id|sector_name|sector_description|sector_image|sector_data|sector_visibility|sector_create_time|sector_valid'.split('|');
	static readonly COL_ID:string = 'sector_id';
	static readonly COL_NAME:string = 'sector_name';
	static readonly COL_DESCRIPTION:string = 'sector_description';
	static readonly COL_IMAGE:string = 'sector_image';
	static readonly COL_DATA:string = 'sector_data';
	static readonly COL_VISIBILITY:string = 'sector_visibility';
	static readonly COL_CREATE_TIME:string = 'sector_create_time';
	static readonly COL_VALID:string = 'sector_valid';

	constructor(data?: tGoblEntityData) {
		super(data, "SXSector", SXSector.PREFIX, SXSector.COLUMNS);
	}
	
	singlePKValue(){
		return this.id;
	}
	identifierColumns(){
		return [SXSector.COL_ID,];
	}
	static fromCache(cache_key: string): SXSector | undefined {
		let cache = <any>gobl_cache["SXSector"];
		return cache && cache[cache_key];
	}

	get id(){ return _c_string(this._data[SXSector.COL_ID])}
	set id(nVal:any){ this._set(SXSector.COL_ID, _c_string(nVal))}
	getId(){ return this.id}
	setId(nVal:any):this { this.id = nVal; return this}
	get name(){ return _c_string(this._data[SXSector.COL_NAME])}
	set name(nVal:any){ this._set(SXSector.COL_NAME, _c_string(nVal))}
	getName(){ return this.name}
	setName(nVal:any):this { this.name = nVal; return this}
	get description(){ return _c_string(this._data[SXSector.COL_DESCRIPTION])}
	set description(nVal:any){ this._set(SXSector.COL_DESCRIPTION, _c_string(nVal))}
	getDescription(){ return this.description}
	setDescription(nVal:any):this { this.description = nVal; return this}
	get image(){ return _c_string(this._data[SXSector.COL_IMAGE])}
	set image(nVal:any){ this._set(SXSector.COL_IMAGE, _c_string(nVal))}
	getImage(){ return this.image}
	setImage(nVal:any):this { this.image = nVal; return this}
	get data(){ return _c_string(this._data[SXSector.COL_DATA])}
	set data(nVal:any){ this._set(SXSector.COL_DATA, _c_string(nVal))}
	getData(){ return this.data}
	setData(nVal:any):this { this.data = nVal; return this}
	get visibility(){ return _c_bool(this._data[SXSector.COL_VISIBILITY])}
	set visibility(nVal:any){ this._set(SXSector.COL_VISIBILITY, _c_bool(nVal))}
	getVisibility(){ return this.visibility}
	setVisibility(nVal:any):this { this.visibility = nVal; return this}
	get create_time(){ return _c_string(this._data[SXSector.COL_CREATE_TIME])}
	set create_time(nVal:any){ this._set(SXSector.COL_CREATE_TIME, _c_string(nVal))}
	getCreateTime(){ return this.create_time}
	setCreateTime(nVal:any):this { this.create_time = nVal; return this}
	get valid(){ return _c_bool(this._data[SXSector.COL_VALID])}
	set valid(nVal:any){ this._set(SXSector.COL_VALID, _c_bool(nVal))}
	getValid(){ return this.valid}
	setValid(nVal:any):this { this.valid = nVal; return this}

}

gobl.SXSector = SXSector;
export class SXCompany extends GoblEntity {
	static readonly PREFIX:string = 'company';
	static readonly COLUMNS:string[] = 'company_id|company_sector_id|company_owner_id|company_name|company_description|company_image|company_type|company_data|company_visibility|company_create_time|company_valid'.split('|');
	static readonly COL_ID:string = 'company_id';
	static readonly COL_SECTOR_ID:string = 'company_sector_id';
	static readonly COL_OWNER_ID:string = 'company_owner_id';
	static readonly COL_NAME:string = 'company_name';
	static readonly COL_DESCRIPTION:string = 'company_description';
	static readonly COL_IMAGE:string = 'company_image';
	static readonly COL_TYPE:string = 'company_type';
	static readonly COL_DATA:string = 'company_data';
	static readonly COL_VISIBILITY:string = 'company_visibility';
	static readonly COL_CREATE_TIME:string = 'company_create_time';
	static readonly COL_VALID:string = 'company_valid';

	constructor(data?: tGoblEntityData) {
		super(data, "SXCompany", SXCompany.PREFIX, SXCompany.COLUMNS);
	}
	
	singlePKValue(){
		return this.id;
	}
	identifierColumns(){
		return [SXCompany.COL_ID,];
	}
	static fromCache(cache_key: string): SXCompany | undefined {
		let cache = <any>gobl_cache["SXCompany"];
		return cache && cache[cache_key];
	}

	get id(){ return _c_string(this._data[SXCompany.COL_ID])}
	set id(nVal:any){ this._set(SXCompany.COL_ID, _c_string(nVal))}
	getId(){ return this.id}
	setId(nVal:any):this { this.id = nVal; return this}
	get sector_id(){ return _c_string(this._data[SXCompany.COL_SECTOR_ID])}
	set sector_id(nVal:any){ this._set(SXCompany.COL_SECTOR_ID, _c_string(nVal))}
	getSectorId(){ return this.sector_id}
	setSectorId(nVal:any):this { this.sector_id = nVal; return this}
	get owner_id(){ return _c_string(this._data[SXCompany.COL_OWNER_ID])}
	set owner_id(nVal:any){ this._set(SXCompany.COL_OWNER_ID, _c_string(nVal))}
	getOwnerId(){ return this.owner_id}
	setOwnerId(nVal:any):this { this.owner_id = nVal; return this}
	get name(){ return _c_string(this._data[SXCompany.COL_NAME])}
	set name(nVal:any){ this._set(SXCompany.COL_NAME, _c_string(nVal))}
	getName(){ return this.name}
	setName(nVal:any):this { this.name = nVal; return this}
	get description(){ return _c_string(this._data[SXCompany.COL_DESCRIPTION])}
	set description(nVal:any){ this._set(SXCompany.COL_DESCRIPTION, _c_string(nVal))}
	getDescription(){ return this.description}
	setDescription(nVal:any):this { this.description = nVal; return this}
	get image(){ return _c_string(this._data[SXCompany.COL_IMAGE])}
	set image(nVal:any){ this._set(SXCompany.COL_IMAGE, _c_string(nVal))}
	getImage(){ return this.image}
	setImage(nVal:any):this { this.image = nVal; return this}
	get type(){ return _c_string(this._data[SXCompany.COL_TYPE])}
	set type(nVal:any){ this._set(SXCompany.COL_TYPE, _c_string(nVal))}
	getType(){ return this.type}
	setType(nVal:any):this { this.type = nVal; return this}
	get data(){ return _c_string(this._data[SXCompany.COL_DATA])}
	set data(nVal:any){ this._set(SXCompany.COL_DATA, _c_string(nVal))}
	getData(){ return this.data}
	setData(nVal:any):this { this.data = nVal; return this}
	get visibility(){ return _c_bool(this._data[SXCompany.COL_VISIBILITY])}
	set visibility(nVal:any){ this._set(SXCompany.COL_VISIBILITY, _c_bool(nVal))}
	getVisibility(){ return this.visibility}
	setVisibility(nVal:any):this { this.visibility = nVal; return this}
	get create_time(){ return _c_string(this._data[SXCompany.COL_CREATE_TIME])}
	set create_time(nVal:any){ this._set(SXCompany.COL_CREATE_TIME, _c_string(nVal))}
	getCreateTime(){ return this.create_time}
	setCreateTime(nVal:any):this { this.create_time = nVal; return this}
	get valid(){ return _c_bool(this._data[SXCompany.COL_VALID])}
	set valid(nVal:any){ this._set(SXCompany.COL_VALID, _c_bool(nVal))}
	getValid(){ return this.valid}
	setValid(nVal:any):this { this.valid = nVal; return this}

}

gobl.SXCompany = SXCompany;
export class SXCompanyAdmin extends GoblEntity {
	static readonly PREFIX:string = 'company_admin';
	static readonly COLUMNS:string[] = 'company_admin_id|company_admin_company_id|company_admin_user_id|company_admin_data|company_admin_create_time|company_admin_valid'.split('|');
	static readonly COL_ID:string = 'company_admin_id';
	static readonly COL_COMPANY_ID:string = 'company_admin_company_id';
	static readonly COL_USER_ID:string = 'company_admin_user_id';
	static readonly COL_DATA:string = 'company_admin_data';
	static readonly COL_CREATE_TIME:string = 'company_admin_create_time';
	static readonly COL_VALID:string = 'company_admin_valid';

	constructor(data?: tGoblEntityData) {
		super(data, "SXCompanyAdmin", SXCompanyAdmin.PREFIX, SXCompanyAdmin.COLUMNS);
	}
	
	singlePKValue(){
		return this.id;
	}
	identifierColumns(){
		return [SXCompanyAdmin.COL_ID,];
	}
	static fromCache(cache_key: string): SXCompanyAdmin | undefined {
		let cache = <any>gobl_cache["SXCompanyAdmin"];
		return cache && cache[cache_key];
	}

	get id(){ return _c_string(this._data[SXCompanyAdmin.COL_ID])}
	set id(nVal:any){ this._set(SXCompanyAdmin.COL_ID, _c_string(nVal))}
	getId(){ return this.id}
	setId(nVal:any):this { this.id = nVal; return this}
	get company_id(){ return _c_string(this._data[SXCompanyAdmin.COL_COMPANY_ID])}
	set company_id(nVal:any){ this._set(SXCompanyAdmin.COL_COMPANY_ID, _c_string(nVal))}
	getCompanyId(){ return this.company_id}
	setCompanyId(nVal:any):this { this.company_id = nVal; return this}
	get user_id(){ return _c_string(this._data[SXCompanyAdmin.COL_USER_ID])}
	set user_id(nVal:any){ this._set(SXCompanyAdmin.COL_USER_ID, _c_string(nVal))}
	getUserId(){ return this.user_id}
	setUserId(nVal:any):this { this.user_id = nVal; return this}
	get data(){ return _c_string(this._data[SXCompanyAdmin.COL_DATA])}
	set data(nVal:any){ this._set(SXCompanyAdmin.COL_DATA, _c_string(nVal))}
	getData(){ return this.data}
	setData(nVal:any):this { this.data = nVal; return this}
	get create_time(){ return _c_string(this._data[SXCompanyAdmin.COL_CREATE_TIME])}
	set create_time(nVal:any){ this._set(SXCompanyAdmin.COL_CREATE_TIME, _c_string(nVal))}
	getCreateTime(){ return this.create_time}
	setCreateTime(nVal:any):this { this.create_time = nVal; return this}
	get valid(){ return _c_bool(this._data[SXCompanyAdmin.COL_VALID])}
	set valid(nVal:any){ this._set(SXCompanyAdmin.COL_VALID, _c_bool(nVal))}
	getValid(){ return this.valid}
	setValid(nVal:any):this { this.valid = nVal; return this}

}

gobl.SXCompanyAdmin = SXCompanyAdmin;
export class SXSurvey extends GoblEntity {
	static readonly PREFIX:string = 'survey';
	static readonly COLUMNS:string[] = 'survey_id|survey_company_id|survey_name|survey_description|survey_image|survey_require_user|survey_data|survey_visibility|survey_create_time|survey_valid'.split('|');
	static readonly COL_ID:string = 'survey_id';
	static readonly COL_COMPANY_ID:string = 'survey_company_id';
	static readonly COL_NAME:string = 'survey_name';
	static readonly COL_DESCRIPTION:string = 'survey_description';
	static readonly COL_IMAGE:string = 'survey_image';
	static readonly COL_REQUIRE_USER:string = 'survey_require_user';
	static readonly COL_DATA:string = 'survey_data';
	static readonly COL_VISIBILITY:string = 'survey_visibility';
	static readonly COL_CREATE_TIME:string = 'survey_create_time';
	static readonly COL_VALID:string = 'survey_valid';

	constructor(data?: tGoblEntityData) {
		super(data, "SXSurvey", SXSurvey.PREFIX, SXSurvey.COLUMNS);
	}
	
	singlePKValue(){
		return this.id;
	}
	identifierColumns(){
		return [SXSurvey.COL_ID,];
	}
	static fromCache(cache_key: string): SXSurvey | undefined {
		let cache = <any>gobl_cache["SXSurvey"];
		return cache && cache[cache_key];
	}

	get id(){ return _c_string(this._data[SXSurvey.COL_ID])}
	set id(nVal:any){ this._set(SXSurvey.COL_ID, _c_string(nVal))}
	getId(){ return this.id}
	setId(nVal:any):this { this.id = nVal; return this}
	get company_id(){ return _c_string(this._data[SXSurvey.COL_COMPANY_ID])}
	set company_id(nVal:any){ this._set(SXSurvey.COL_COMPANY_ID, _c_string(nVal))}
	getCompanyId(){ return this.company_id}
	setCompanyId(nVal:any):this { this.company_id = nVal; return this}
	get name(){ return _c_string(this._data[SXSurvey.COL_NAME])}
	set name(nVal:any){ this._set(SXSurvey.COL_NAME, _c_string(nVal))}
	getName(){ return this.name}
	setName(nVal:any):this { this.name = nVal; return this}
	get description(){ return _c_string(this._data[SXSurvey.COL_DESCRIPTION])}
	set description(nVal:any){ this._set(SXSurvey.COL_DESCRIPTION, _c_string(nVal))}
	getDescription(){ return this.description}
	setDescription(nVal:any):this { this.description = nVal; return this}
	get image(){ return _c_string(this._data[SXSurvey.COL_IMAGE])}
	set image(nVal:any){ this._set(SXSurvey.COL_IMAGE, _c_string(nVal))}
	getImage(){ return this.image}
	setImage(nVal:any):this { this.image = nVal; return this}
	get require_user(){ return _c_bool(this._data[SXSurvey.COL_REQUIRE_USER])}
	set require_user(nVal:any){ this._set(SXSurvey.COL_REQUIRE_USER, _c_bool(nVal))}
	getRequireUser(){ return this.require_user}
	setRequireUser(nVal:any):this { this.require_user = nVal; return this}
	get data(){ return _c_string(this._data[SXSurvey.COL_DATA])}
	set data(nVal:any){ this._set(SXSurvey.COL_DATA, _c_string(nVal))}
	getData(){ return this.data}
	setData(nVal:any):this { this.data = nVal; return this}
	get visibility(){ return _c_bool(this._data[SXSurvey.COL_VISIBILITY])}
	set visibility(nVal:any){ this._set(SXSurvey.COL_VISIBILITY, _c_bool(nVal))}
	getVisibility(){ return this.visibility}
	setVisibility(nVal:any):this { this.visibility = nVal; return this}
	get create_time(){ return _c_string(this._data[SXSurvey.COL_CREATE_TIME])}
	set create_time(nVal:any){ this._set(SXSurvey.COL_CREATE_TIME, _c_string(nVal))}
	getCreateTime(){ return this.create_time}
	setCreateTime(nVal:any):this { this.create_time = nVal; return this}
	get valid(){ return _c_bool(this._data[SXSurvey.COL_VALID])}
	set valid(nVal:any){ this._set(SXSurvey.COL_VALID, _c_bool(nVal))}
	getValid(){ return this.valid}
	setValid(nVal:any):this { this.valid = nVal; return this}

}

gobl.SXSurvey = SXSurvey;
export class SXUrl extends GoblEntity {
	static readonly PREFIX:string = 'url';
	static readonly COLUMNS:string[] = 'url_id|url_owner_id|url_hash|url_target|url_data|url_create_time|url_valid'.split('|');
	static readonly COL_ID:string = 'url_id';
	static readonly COL_OWNER_ID:string = 'url_owner_id';
	static readonly COL_HASH:string = 'url_hash';
	static readonly COL_TARGET:string = 'url_target';
	static readonly COL_DATA:string = 'url_data';
	static readonly COL_CREATE_TIME:string = 'url_create_time';
	static readonly COL_VALID:string = 'url_valid';

	constructor(data?: tGoblEntityData) {
		super(data, "SXUrl", SXUrl.PREFIX, SXUrl.COLUMNS);
	}
	
	singlePKValue(){
		return this.id;
	}
	identifierColumns(){
		return [SXUrl.COL_ID,];
	}
	static fromCache(cache_key: string): SXUrl | undefined {
		let cache = <any>gobl_cache["SXUrl"];
		return cache && cache[cache_key];
	}

	get id(){ return _c_string(this._data[SXUrl.COL_ID])}
	set id(nVal:any){ this._set(SXUrl.COL_ID, _c_string(nVal))}
	getId(){ return this.id}
	setId(nVal:any):this { this.id = nVal; return this}
	get owner_id(){ return _c_string(this._data[SXUrl.COL_OWNER_ID])}
	set owner_id(nVal:any){ this._set(SXUrl.COL_OWNER_ID, _c_string(nVal))}
	getOwnerId(){ return this.owner_id}
	setOwnerId(nVal:any):this { this.owner_id = nVal; return this}
	get hash(){ return _c_string(this._data[SXUrl.COL_HASH])}
	set hash(nVal:any){ this._set(SXUrl.COL_HASH, _c_string(nVal))}
	getHash(){ return this.hash}
	setHash(nVal:any):this { this.hash = nVal; return this}
	get target(){ return _c_string(this._data[SXUrl.COL_TARGET])}
	set target(nVal:any){ this._set(SXUrl.COL_TARGET, _c_string(nVal))}
	getTarget(){ return this.target}
	setTarget(nVal:any):this { this.target = nVal; return this}
	get data(){ return _c_string(this._data[SXUrl.COL_DATA])}
	set data(nVal:any){ this._set(SXUrl.COL_DATA, _c_string(nVal))}
	getData(){ return this.data}
	setData(nVal:any):this { this.data = nVal; return this}
	get create_time(){ return _c_string(this._data[SXUrl.COL_CREATE_TIME])}
	set create_time(nVal:any){ this._set(SXUrl.COL_CREATE_TIME, _c_string(nVal))}
	getCreateTime(){ return this.create_time}
	setCreateTime(nVal:any):this { this.create_time = nVal; return this}
	get valid(){ return _c_bool(this._data[SXUrl.COL_VALID])}
	set valid(nVal:any){ this._set(SXUrl.COL_VALID, _c_bool(nVal))}
	getValid(){ return this.valid}
	setValid(nVal:any):this { this.valid = nVal; return this}

}

gobl.SXUrl = SXUrl;
export class SXQuestion extends GoblEntity {
	static readonly PREFIX:string = 'question';
	static readonly COLUMNS:string[] = 'question_id|question_survey_id|question_uuid|question_label|question_index|question_type|question_data|question_create_time|question_valid'.split('|');
	static readonly COL_ID:string = 'question_id';
	static readonly COL_SURVEY_ID:string = 'question_survey_id';
	static readonly COL_UUID:string = 'question_uuid';
	static readonly COL_LABEL:string = 'question_label';
	static readonly COL_INDEX:string = 'question_index';
	static readonly COL_TYPE:string = 'question_type';
	static readonly COL_DATA:string = 'question_data';
	static readonly COL_CREATE_TIME:string = 'question_create_time';
	static readonly COL_VALID:string = 'question_valid';

	constructor(data?: tGoblEntityData) {
		super(data, "SXQuestion", SXQuestion.PREFIX, SXQuestion.COLUMNS);
	}
	
	singlePKValue(){
		return this.id;
	}
	identifierColumns(){
		return [SXQuestion.COL_ID,];
	}
	static fromCache(cache_key: string): SXQuestion | undefined {
		let cache = <any>gobl_cache["SXQuestion"];
		return cache && cache[cache_key];
	}

	get id(){ return _c_string(this._data[SXQuestion.COL_ID])}
	set id(nVal:any){ this._set(SXQuestion.COL_ID, _c_string(nVal))}
	getId(){ return this.id}
	setId(nVal:any):this { this.id = nVal; return this}
	get survey_id(){ return _c_string(this._data[SXQuestion.COL_SURVEY_ID])}
	set survey_id(nVal:any){ this._set(SXQuestion.COL_SURVEY_ID, _c_string(nVal))}
	getSurveyId(){ return this.survey_id}
	setSurveyId(nVal:any):this { this.survey_id = nVal; return this}
	get uuid(){ return _c_string(this._data[SXQuestion.COL_UUID])}
	set uuid(nVal:any){ this._set(SXQuestion.COL_UUID, _c_string(nVal))}
	getUuid(){ return this.uuid}
	setUuid(nVal:any):this { this.uuid = nVal; return this}
	get label(){ return _c_string(this._data[SXQuestion.COL_LABEL])}
	set label(nVal:any){ this._set(SXQuestion.COL_LABEL, _c_string(nVal))}
	getLabel(){ return this.label}
	setLabel(nVal:any):this { this.label = nVal; return this}
	get index(){ return _c_int(this._data[SXQuestion.COL_INDEX])}
	set index(nVal:any){ this._set(SXQuestion.COL_INDEX, _c_int(nVal))}
	getIndex(){ return this.index}
	setIndex(nVal:any):this { this.index = nVal; return this}
	get type(){ return _c_string(this._data[SXQuestion.COL_TYPE])}
	set type(nVal:any){ this._set(SXQuestion.COL_TYPE, _c_string(nVal))}
	getType(){ return this.type}
	setType(nVal:any):this { this.type = nVal; return this}
	get data(){ return _c_string(this._data[SXQuestion.COL_DATA])}
	set data(nVal:any){ this._set(SXQuestion.COL_DATA, _c_string(nVal))}
	getData(){ return this.data}
	setData(nVal:any):this { this.data = nVal; return this}
	get create_time(){ return _c_string(this._data[SXQuestion.COL_CREATE_TIME])}
	set create_time(nVal:any){ this._set(SXQuestion.COL_CREATE_TIME, _c_string(nVal))}
	getCreateTime(){ return this.create_time}
	setCreateTime(nVal:any):this { this.create_time = nVal; return this}
	get valid(){ return _c_bool(this._data[SXQuestion.COL_VALID])}
	set valid(nVal:any){ this._set(SXQuestion.COL_VALID, _c_bool(nVal))}
	getValid(){ return this.valid}
	setValid(nVal:any):this { this.valid = nVal; return this}

}

gobl.SXQuestion = SXQuestion;
export class SXChoice extends GoblEntity {
	static readonly PREFIX:string = 'choice';
	static readonly COLUMNS:string[] = 'choice_id|choice_question_id|choice_uuid|choice_label|choice_index|choice_data|choice_create_time|choice_valid'.split('|');
	static readonly COL_ID:string = 'choice_id';
	static readonly COL_QUESTION_ID:string = 'choice_question_id';
	static readonly COL_UUID:string = 'choice_uuid';
	static readonly COL_LABEL:string = 'choice_label';
	static readonly COL_INDEX:string = 'choice_index';
	static readonly COL_DATA:string = 'choice_data';
	static readonly COL_CREATE_TIME:string = 'choice_create_time';
	static readonly COL_VALID:string = 'choice_valid';

	constructor(data?: tGoblEntityData) {
		super(data, "SXChoice", SXChoice.PREFIX, SXChoice.COLUMNS);
	}
	
	singlePKValue(){
		return this.id;
	}
	identifierColumns(){
		return [SXChoice.COL_ID,];
	}
	static fromCache(cache_key: string): SXChoice | undefined {
		let cache = <any>gobl_cache["SXChoice"];
		return cache && cache[cache_key];
	}

	get id(){ return _c_string(this._data[SXChoice.COL_ID])}
	set id(nVal:any){ this._set(SXChoice.COL_ID, _c_string(nVal))}
	getId(){ return this.id}
	setId(nVal:any):this { this.id = nVal; return this}
	get question_id(){ return _c_string(this._data[SXChoice.COL_QUESTION_ID])}
	set question_id(nVal:any){ this._set(SXChoice.COL_QUESTION_ID, _c_string(nVal))}
	getQuestionId(){ return this.question_id}
	setQuestionId(nVal:any):this { this.question_id = nVal; return this}
	get uuid(){ return _c_string(this._data[SXChoice.COL_UUID])}
	set uuid(nVal:any){ this._set(SXChoice.COL_UUID, _c_string(nVal))}
	getUuid(){ return this.uuid}
	setUuid(nVal:any):this { this.uuid = nVal; return this}
	get label(){ return _c_string(this._data[SXChoice.COL_LABEL])}
	set label(nVal:any){ this._set(SXChoice.COL_LABEL, _c_string(nVal))}
	getLabel(){ return this.label}
	setLabel(nVal:any):this { this.label = nVal; return this}
	get index(){ return _c_int(this._data[SXChoice.COL_INDEX])}
	set index(nVal:any){ this._set(SXChoice.COL_INDEX, _c_int(nVal))}
	getIndex(){ return this.index}
	setIndex(nVal:any):this { this.index = nVal; return this}
	get data(){ return _c_string(this._data[SXChoice.COL_DATA])}
	set data(nVal:any){ this._set(SXChoice.COL_DATA, _c_string(nVal))}
	getData(){ return this.data}
	setData(nVal:any):this { this.data = nVal; return this}
	get create_time(){ return _c_string(this._data[SXChoice.COL_CREATE_TIME])}
	set create_time(nVal:any){ this._set(SXChoice.COL_CREATE_TIME, _c_string(nVal))}
	getCreateTime(){ return this.create_time}
	setCreateTime(nVal:any):this { this.create_time = nVal; return this}
	get valid(){ return _c_bool(this._data[SXChoice.COL_VALID])}
	set valid(nVal:any){ this._set(SXChoice.COL_VALID, _c_bool(nVal))}
	getValid(){ return this.valid}
	setValid(nVal:any):this { this.valid = nVal; return this}

}

gobl.SXChoice = SXChoice;
export class SXAnswer extends GoblEntity {
	static readonly PREFIX:string = 'answer';
	static readonly COLUMNS:string[] = 'answer_id|answer_user_id|answer_by_id|answer_survey_id|answer_value|answer_data|answer_create_time|answer_valid'.split('|');
	static readonly COL_ID:string = 'answer_id';
	static readonly COL_USER_ID:string = 'answer_user_id';
	static readonly COL_BY_ID:string = 'answer_by_id';
	static readonly COL_SURVEY_ID:string = 'answer_survey_id';
	static readonly COL_VALUE:string = 'answer_value';
	static readonly COL_DATA:string = 'answer_data';
	static readonly COL_CREATE_TIME:string = 'answer_create_time';
	static readonly COL_VALID:string = 'answer_valid';

	constructor(data?: tGoblEntityData) {
		super(data, "SXAnswer", SXAnswer.PREFIX, SXAnswer.COLUMNS);
	}
	
	singlePKValue(){
		return this.id;
	}
	identifierColumns(){
		return [SXAnswer.COL_ID,];
	}
	static fromCache(cache_key: string): SXAnswer | undefined {
		let cache = <any>gobl_cache["SXAnswer"];
		return cache && cache[cache_key];
	}

	get id(){ return _c_string(this._data[SXAnswer.COL_ID])}
	set id(nVal:any){ this._set(SXAnswer.COL_ID, _c_string(nVal))}
	getId(){ return this.id}
	setId(nVal:any):this { this.id = nVal; return this}
	get user_id(){ return _c_string(this._data[SXAnswer.COL_USER_ID])}
	set user_id(nVal:any){ this._set(SXAnswer.COL_USER_ID, _c_string(nVal))}
	getUserId(){ return this.user_id}
	setUserId(nVal:any):this { this.user_id = nVal; return this}
	get by_id(){ return _c_string(this._data[SXAnswer.COL_BY_ID])}
	set by_id(nVal:any){ this._set(SXAnswer.COL_BY_ID, _c_string(nVal))}
	getBYId(){ return this.by_id}
	setBYId(nVal:any):this { this.by_id = nVal; return this}
	get survey_id(){ return _c_string(this._data[SXAnswer.COL_SURVEY_ID])}
	set survey_id(nVal:any){ this._set(SXAnswer.COL_SURVEY_ID, _c_string(nVal))}
	getSurveyId(){ return this.survey_id}
	setSurveyId(nVal:any):this { this.survey_id = nVal; return this}
	get value(){ return _c_string(this._data[SXAnswer.COL_VALUE])}
	set value(nVal:any){ this._set(SXAnswer.COL_VALUE, _c_string(nVal))}
	getValue(){ return this.value}
	setValue(nVal:any):this { this.value = nVal; return this}
	get data(){ return _c_string(this._data[SXAnswer.COL_DATA])}
	set data(nVal:any){ this._set(SXAnswer.COL_DATA, _c_string(nVal))}
	getData(){ return this.data}
	setData(nVal:any):this { this.data = nVal; return this}
	get create_time(){ return _c_string(this._data[SXAnswer.COL_CREATE_TIME])}
	set create_time(nVal:any){ this._set(SXAnswer.COL_CREATE_TIME, _c_string(nVal))}
	getCreateTime(){ return this.create_time}
	setCreateTime(nVal:any):this { this.create_time = nVal; return this}
	get valid(){ return _c_bool(this._data[SXAnswer.COL_VALID])}
	set valid(nVal:any){ this._set(SXAnswer.COL_VALID, _c_bool(nVal))}
	getValid(){ return this.valid}
	setValid(nVal:any):this { this.valid = nVal; return this}

}

gobl.SXAnswer = SXAnswer;
export class SXAnswerAtom extends GoblEntity {
	static readonly PREFIX:string = 'aa';
	static readonly COLUMNS:string[] = 'aa_id|aa_survey_id|aa_answer_id|aa_question_id|aa_value|aa_data|aa_create_time|aa_valid'.split('|');
	static readonly COL_ID:string = 'aa_id';
	static readonly COL_SURVEY_ID:string = 'aa_survey_id';
	static readonly COL_ANSWER_ID:string = 'aa_answer_id';
	static readonly COL_QUESTION_ID:string = 'aa_question_id';
	static readonly COL_VALUE:string = 'aa_value';
	static readonly COL_DATA:string = 'aa_data';
	static readonly COL_CREATE_TIME:string = 'aa_create_time';
	static readonly COL_VALID:string = 'aa_valid';

	constructor(data?: tGoblEntityData) {
		super(data, "SXAnswerAtom", SXAnswerAtom.PREFIX, SXAnswerAtom.COLUMNS);
	}
	
	singlePKValue(){
		return this.id;
	}
	identifierColumns(){
		return [SXAnswerAtom.COL_ID,];
	}
	static fromCache(cache_key: string): SXAnswerAtom | undefined {
		let cache = <any>gobl_cache["SXAnswerAtom"];
		return cache && cache[cache_key];
	}

	get id(){ return _c_string(this._data[SXAnswerAtom.COL_ID])}
	set id(nVal:any){ this._set(SXAnswerAtom.COL_ID, _c_string(nVal))}
	getId(){ return this.id}
	setId(nVal:any):this { this.id = nVal; return this}
	get survey_id(){ return _c_string(this._data[SXAnswerAtom.COL_SURVEY_ID])}
	set survey_id(nVal:any){ this._set(SXAnswerAtom.COL_SURVEY_ID, _c_string(nVal))}
	getSurveyId(){ return this.survey_id}
	setSurveyId(nVal:any):this { this.survey_id = nVal; return this}
	get answer_id(){ return _c_string(this._data[SXAnswerAtom.COL_ANSWER_ID])}
	set answer_id(nVal:any){ this._set(SXAnswerAtom.COL_ANSWER_ID, _c_string(nVal))}
	getAnswerId(){ return this.answer_id}
	setAnswerId(nVal:any):this { this.answer_id = nVal; return this}
	get question_id(){ return _c_string(this._data[SXAnswerAtom.COL_QUESTION_ID])}
	set question_id(nVal:any){ this._set(SXAnswerAtom.COL_QUESTION_ID, _c_string(nVal))}
	getQuestionId(){ return this.question_id}
	setQuestionId(nVal:any):this { this.question_id = nVal; return this}
	get value(){ return _c_string(this._data[SXAnswerAtom.COL_VALUE])}
	set value(nVal:any){ this._set(SXAnswerAtom.COL_VALUE, _c_string(nVal))}
	getValue(){ return this.value}
	setValue(nVal:any):this { this.value = nVal; return this}
	get data(){ return _c_string(this._data[SXAnswerAtom.COL_DATA])}
	set data(nVal:any){ this._set(SXAnswerAtom.COL_DATA, _c_string(nVal))}
	getData(){ return this.data}
	setData(nVal:any):this { this.data = nVal; return this}
	get create_time(){ return _c_string(this._data[SXAnswerAtom.COL_CREATE_TIME])}
	set create_time(nVal:any){ this._set(SXAnswerAtom.COL_CREATE_TIME, _c_string(nVal))}
	getCreateTime(){ return this.create_time}
	setCreateTime(nVal:any):this { this.create_time = nVal; return this}
	get valid(){ return _c_bool(this._data[SXAnswerAtom.COL_VALID])}
	set valid(nVal:any){ this._set(SXAnswerAtom.COL_VALID, _c_bool(nVal))}
	getValid(){ return this.valid}
	setValid(nVal:any):this { this.valid = nVal; return this}

}

gobl.SXAnswerAtom = SXAnswerAtom;

Object.keys(gobl).forEach(function (entity) {
	gobl_cache[ entity ] = {};
	gobl_class_magic_map[ gobl[ entity ][ "COLUMNS" ].sort().join("") ] = entity;
});

JSON.parse = goblJSONParse;

console.log("[gobl] ready!");
